import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  IconButton,
  Tabs,
  Tab,
  Skeleton,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { FaTimes } from "react-icons/fa";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: 800, // wider
  bgcolor: "background.paper",
  borderRadius: 8,
  boxShadow: 24,
  p: 3,
  maxHeight: "90vh",
  overflowY: "auto",
};

const tabs = [
  { label: "All", value: "All" },
  { label: "Duration", value: "duration" },
  { label: "Game", value: "game" },
  { label: "Gift", value: "gift" },
];

const durations = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Custom", value: "Custom" },
];

const SkeletonList = () => (
  <>
    {[1, 2, 3, 4, 5].map((i) => (
      <Skeleton
        key={i}
        variant="text"
        height={50}
        // sx={{ mb: 1, borderRadius: 1 }}
        sx={{ fontSize: 32, mb: 1 }}
      />
    ))}
  </>
);

const GangActivityModal = ({ open, onClose, gangInfo }) => {
  const [tab, setTab] = useState("All");
  const [duration, setDuration] = useState("Today");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchActivities = async () => {
    if (!gangInfo._id) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/gang-activity/get-by-gangId/${gangInfo._id}`,
        {
          params: {
            page,
            limit: 10,
            type: tab,
            duration,
            from: from || undefined,
            to: to || undefined,
          },
        }
      );
      setActivities(res.data.activities || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateInput) => {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? " PM" : " AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}/${month}/${year} - ${hours}:${minutes}${ampm}`;
  };

  useEffect(() => {
    setPage(1);
  }, [tab, duration, from, to]);

  useEffect(() => {
    fetchActivities();
  }, [tab, duration, from, to, page, gangInfo._id]);

  // const renderEventText = (event) => {
  //   const time = formatDateTime(event.eventTime);

  //   const commonStyle = "flex items-center gap-2 text-sm p-2 rounded-md";

  //   switch (event.eventType) {
  //     case "LIVE_START":
  //       return (
  //         <div
  //           className={`${commonStyle} bg-green-100 font-semibold text-green-800`}
  //         >
  //           <span className="font-mono">{time}</span>
  //           <span>Gang goes live 🚀</span>
  //         </div>
  //       );

  //     case "LIVE_END":
  //       return (
  //         <div className={`${commonStyle} bg-gray-100 text-gray-800`}>
  //           <span className="font-mono">{time}</span>
  //           <span>
  //             Gang goes offline{" "}
  //             <span className="font-bold">({event.meta.duration} mins)</span>
  //           </span>
  //         </div>
  //       );

  //     case "GIFT":
  //       return (
  //         <div className={`${commonStyle} bg-pink-50 text-pink-800`}>
  //           <span className="font-mono">{time}</span>
  //           <span>
  //             <span className="font-semibold">
  //               {event.meta.sender?.nickName}
  //             </span>{" "}
  //             gifted you{" "}
  //             {event.meta.gift?.emoji && (
  //               <img
  //                 src={event.meta.gift.emoji} // assuming emoji is an image URL
  //                 alt="emoji"
  //                 className="mx-1 inline h-4 w-4"
  //               />
  //             )}
  //             <span className="font-bold text-red-600">
  //               +{event.meta.gift?.coinDeduct}
  //             </span>
  //           </span>
  //         </div>
  //       );

  //     case "GAME_START":
  //       return (
  //         <div
  //           className={`${commonStyle} border-l-4 border-indigo-500 bg-indigo-50 text-indigo-900`}
  //         >
  //           <span className="font-mono text-xs text-indigo-700">{time}</span>

  //           <span>
  //             🎮 <span className="font-semibold">Game started</span> with
  //             co-hosts{" "}
  //             <span className="ml-1 inline-flex flex-wrap gap-1">
  //               {event.meta.coHosts?.map((c) => (
  //                 <span
  //                   key={c._id}
  //                   className="rounded-full bg-indigo-200 px-2 py-0.5 text-xs font-semibold text-indigo-900"
  //                 >
  //                   {c.nickName}
  //                 </span>
  //               ))}
  //             </span>
  //           </span>
  //         </div>
  //       );

  //     case "GAME_END":
  //       return (
  //         <div
  //           className={`${commonStyle} bg-blue-100 font-semibold text-blue-900`}
  //         >
  //           <span className="font-mono">{time}</span>
  //           <span>Game ended 🏁</span>
  //         </div>
  //       );

  //     default:
  //       return null;
  //   }
  // };
  const renderEventText = (event) => {
    const time = formatDateTime(event.eventTime);

    const base = "flex items-start gap-3 rounded-lg p-3 text-sm shadow-sm";

    const timeStyle = "min-w-[130px] text-xs font-mono text-gray-500";

    switch (event.eventType) {
      case "LIVE_START":
        return (
          <div className={`${base} border-l-4 border-green-500 bg-green-50`}>
            <span className={timeStyle}>{time}</span>
            <div className="flex items-center gap-2 font-semibold text-green-800">
              <span className="text-lg">🚀</span>
              <span>Gang went live</span>
            </div>
          </div>
        );

      case "LIVE_END":
        return (
          <div className={`${base} border-l-4 border-blue-400 bg-blue-50`}>
            <span className={timeStyle}>{time}</span>
            <div className="text-blue-800">
              <span className="font-semibold">Gang went offline</span>
              <span className="ml-2 rounded bg-blue-200 px-2 py-0.5 text-xs font-bold">
                {event.meta.duration} mins
              </span>
            </div>
          </div>
        );

      case "GIFT":
        return (
          <div className={`${base} border-l-4 border-orange-500 bg-orange-50`}>
            <span className={timeStyle}>{time}</span>
            <div className="flex items-center gap-2 text-orange-900">
              <span className="font-semibold">
                {event.meta.sender?.nickName}
              </span>
              <span>sent a gift</span>

              {event.meta.gift?.emoji && (
                <img
                  src={event.meta.gift.emoji}
                  alt="gift"
                  className="h-5 w-5"
                />
              )}

              <span className="rounded bg-orange-200 px-2 py-0.5 text-xs font-bold text-pink-900">
                +{event.meta.gift?.coinDeduct}
              </span>
            </div>
          </div>
        );

      case "GAME_START":
        return (
          <div className={`${base} border-l-4 border-indigo-500 bg-indigo-50`}>
            <span className={timeStyle}>{time}</span>

            <div className="flex  gap-1 text-indigo-900">
              <div className="flex items-center gap-2 font-semibold">
                <span className="text-lg">🎮</span>
                <span>Game started with co-hosts</span>
              </div>

              <div className="flex flex-wrap gap-1">
                {event.meta.coHosts?.map((c) => (
                  <span
                    key={c._id}
                    className="flex items-center rounded-lg bg-indigo-200 px-2 py-0.5 text-xs font-semibold text-indigo-900"
                  >
                    {c.nickName}
                  </span>
                ))}
              </div>
            </div>
          </div>
        );

      case "GAME_END":
        return (
          <div className={`${base} border-l-4 border-red-500 bg-red-50`}>
            <span className={timeStyle}>{time}</span>
            <div className="flex items-center gap-2 font-semibold text-red-900">
              <span className="text-lg">🏁</span>
              <span>Game ended</span>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "#a10f5b" }}
        >
          <FaTimes />
        </IconButton>

        <h2 className="mb-4 text-center text-2xl font-bold text-[#a10f5b]">
          Gang Activity
        </h2>

        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="fullWidth"
          sx={{
            mb: 2,
            "& .MuiTabs-indicator": {
              backgroundColor: "#a10f5b", // underline color
            },
            "& .MuiTab-root": {
              color: "#000", // default tab text color
              "&.Mui-selected": {
                color: "#a10f5b", // selected tab text color
              },
            },
          }}
        >
          {tabs.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>

        {/* Duration Filters */}
        <Box className="mb-3 flex flex-wrap gap-2">
          <TextField
            select
            label="Duration"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            size="small"
            sx={{ minWidth: 120 }}
          >
            {durations.map((d) => (
              <MenuItem key={d.value} value={d.value}>
                {d.label}
              </MenuItem>
            ))}
          </TextField>

          {duration === "Custom" && (
            <>
              <TextField
                label="From"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
              <TextField
                label="To"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </>
          )}
        </Box>

        {/* Content */}
        {loading ? (
          <SkeletonList />
        ) : activities.length === 0 ? (
          <p className="text-center text-gray-500">No activity found</p>
        ) : (
          <div className="space-y-2">
            {activities.map((event) => (
              <div
                key={event._id}
                className="rounded-md border p-2 text-sm text-gray-700"
              >
                {renderEventText(event)}
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        <div className="mt-3 flex justify-between">
          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
            className="rounded bg-gray-200 px-3 py-1 disabled:opacity-50"
          >
            Prev
          </button>
          <span className="text-sm">
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
            className="rounded bg-gray-200 px-3 py-1 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default GangActivityModal;
